/**
 * The app's react-query client. AuthProvider creates one per signed-in session
 * (CASA 6.6.1): a sign-out clears the old client and discards it, so a query or
 * mutation of the signed-out user that lands late writes into a client nobody
 * reads any more.
 */

import { QueryClient } from '@tanstack/react-query';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 1,
      },
    },
  });
}
